import React, { useEffect, useState } from "react";
import Modal from "../ReactNativeModal";
import { ModalContent, Typography, Divider, Box } from "digiwash-components";
import RadioRow from "../RadioRow";
import useScrollLock from "../../hooks/useScrollLock";

interface Workspace {
  name: string;
  logo: string;
  id: string;
}
interface SubscriptionModalProps {
  onDismiss: () => void;
  isModalOpen: boolean;
  workspaces: Workspace[];
  onSelect: (workspace: string) => void;
  activeWorkspace: string;
}

const SubscriptionModal = (props: SubscriptionModalProps) => {
  let { workspaces } = props;
  let [selectWorkspace, setSelectWorkspace] = useState<string>(
    props.activeWorkspace
  );

  let { enable, disable } = useScrollLock();
  useEffect(() => {
    if (props.isModalOpen) {
      enable();
    } else {
      disable();
    }
  }, [props.isModalOpen]);

  return (
    <Modal
      isVisible={props.isModalOpen}
      onSwipeComplete={props.onDismiss}
      onBackdropPress={props.onDismiss}
      swipeDirection={["down"]}
      style={{
        justifyContent: "flex-end",
        margin: 0,
        width: "100%",
        alignItems: "center",
      }}
    >
      <ModalContent>
        <Box pt="xxl" pb="l" px="l">
          <Typography ff="mainBold" fs="l" color="common.black">
            انتخاب گروه کاربری
          </Typography>

          <Divider size="xxxl" />
          {workspaces.map((workspace) => {
            return (
              <React.Fragment key={workspace.id}>
                <RadioRow
                  title={
                    workspace.id === "personal" ? "حساب شخصی" : workspace.name
                  }
                  onSelect={() => {
                    setSelectWorkspace(workspace.id);
                    props.onSelect(workspace.id);
                  }}
                  selected={selectWorkspace === workspace.id}
                  icon={
                    workspace.id === "personal" ? "personal" : workspace.logo
                  }
                />
                <Divider size="xxxl" />
              </React.Fragment>
            );
          })}
        </Box>
      </ModalContent>
    </Modal>
  );
};
export default SubscriptionModal;
